module.exports = __webpack_public_path__ + "static/pic2-8034b0d81b5a04ff316aaf89cb636c85.png";